export const vehiclesData = [
    {
        id: 1,
        name: "Innova Crysta",
        image: "assets/img/vehicles/crysta.png",
        specs: {
            passengers: "Driver + 7 Passengers",
            airConditioning: "Yes",
            driverAllowance: "Inclusive",
            perKmCharge: "₹21 per km",
            tollTax: "Inclusive",
            luggageCapacity: "Carrier",
        },
        tripType:"one-way",
    },
    {
        id: 2,
        name: "Sedan",
        image: "assets/img/vehicles/sedan.png",
        specs: {
            passengers: "Driver + 4 Passengers",
            airConditioning: "Yes",
            driverAllowance: "Inclusive",
            perKmCharge: "₹14 per km",
            tollTax: "Inclusive",
            luggageCapacity: "Carrier",
        },
        tripType:"one-way",
    },
    {
        id: 3,
        name: "Ertiga",
        image: "assets/img/vehicles/ertiga.png",
        specs: {
            passengers: "Driver + 6 Passengers",
            airConditioning: "Yes",
            driverAllowance: "Inclusive",
            perKmCharge: "₹15 per km",
            tollTax: "Inclusive",
            luggageCapacity: "Carrier",
        },
        tripType:"one-way",
    }, 
    {
        id: 4,
        name: "Innova",
        image: "assets/img/vehicles/innova.png",
        specs: {
            passengers: "Driver + 7 Passengers",
            airConditioning: "Yes",
            driverAllowance: "Inclusive",
            perKmCharge: "₹18 per km",
            tollTax: "Inclusive",
            luggageCapacity: "Carrier",
        },
        tripType:"one-way",
    },
    {
        id: 5,
        name: "Innova Crysta",
        image: "assets/img/vehicles/crysta.png",
        specs: {
            passengers: "Driver + 7 Passengers",
            airConditioning: "Yes",
            driverAllowance: "Exclusive",
            perKmCharge: "₹17 per km",
            tollTax: "Exclusive",
            luggageCapacity: "Carrier",
        },
        tripType:"round-trip",
    },
    {
        id: 6,
        name: "Sedan",
        image: "assets/img/vehicles/sedan.png",
        specs: {
            passengers: "Driver + 4 Passengers",
            airConditioning: "Yes",
            driverAllowance: "Exclusive",
            perKmCharge: "₹12 per km",
            tollTax: "Exclusive",
            luggageCapacity: "Carrier",
        },
        tripType:"round-trip",
    },
    {
        id: 7,
        name: "Ertiga",
        image: "assets/img/vehicles/ertiga.png",
        specs: {
            passengers: "Driver + 6 Passengers",
            airConditioning: "Yes",
            driverAllowance: "Exclusive",
            perKmCharge: "₹14 per km",
            tollTax: "Exclusive",
            luggageCapacity: "Carrier",
        },
        tripType:"round-trip",
    }, 
    {
        id: 8,
        name: "Innova",
        image: "assets/img/vehicles/innova.png",
        specs: {
            passengers: "Driver + 7 Passengers",
            airConditioning: "Yes",
            driverAllowance: "Exclusive",
            perKmCharge: "₹15 per km",
            tollTax: "Exclusive",
            luggageCapacity: "Carrier",
        },
        tripType:"round-trip",
    },
    {
        id: 9,
        name: "Tempo Traveller",
        image: "assets/img/vehicles/tempo.png",
        specs: {
            passengers: "Driver + 20 Passengers",
            airConditioning: "Yes",
            driverAllowance: "Exclusive",
            perKmCharge: "₹26 per km",
            tollTax: "Exclusive",
            luggageCapacity: "Carrier",
        },
        tripType:"round-trip",
    },
    {
        id: 10,
        name: "Tempo Traveller",
        image: "assets/img/vehicles/tempo.png",
        specs: {
            passengers: "Driver + 20 Passengers",
            airConditioning: "Yes",
            driverAllowance: "Inclusive",
            perKmCharge: "₹30 per km",
            tollTax: "Inclusive",
            luggageCapacity: "Carrier",
        },
        tripType:"one-way",
    },
];